import type {
  InitialObjective,
  PartialObjective,
  StickyUpdatedEvent,
} from "@/backend/natsstubs/board/models";
import type { Objective } from "@/model/objective";
import { isZombieType } from "@/store/stickyType";
import { stickerToString } from "@/utils/sticker";

import type { AlterCard } from "./toBackendData";

export function toApiInitObjective(objective: Objective, isStretch: boolean): InitialObjective {
  return {
    text: objective.text,
    description: objective.description,
    isStretch,
  };
}

export function toApiObjective(data: Partial<Objective>): PartialObjective {
  const value: PartialObjective = {};
  if (data.text !== undefined) {
    value.text = data.text;
  }
  if (data.bv !== undefined) {
    value.bv = data.bv;
  }
  if (data.av !== undefined) {
    value.av = data.av;
  }
  if (data.description !== undefined) {
    value.description = data.description;
  }
  if (data.rag !== undefined) {
    value.rag = data.rag;
  }
  return value;
}

export function toApiSticky(data?: AlterCard, priorities?: boolean): StickyUpdatedEvent {
  const value: StickyUpdatedEvent = {};
  if (data) {
    if (data.x !== undefined && data.y !== undefined) {
      value.aCenter = [data.x, 1 - data.y];
    }
    if (data.zIndex !== undefined) {
      value.stackPos = data.zIndex;
    }
    if (data.text !== undefined) {
      value.text = data.text;
    }
    if (data.status !== undefined) {
      value.status = data.status.name;
      value.statusClass = data.status.statusClass;
    }
    if (data.transition !== undefined) {
      value.transition = data.transition;
    }
    if (data.type !== undefined && !isZombieType(data.type)) {
      value.typeId = data.type.id;
    }
    if (data.priority !== undefined) {
      if (priorities) {
        value.stepValue = data.priority;
      } else {
        value.WSJFValue = data.priority;
      }
    }
    if (data.points !== undefined) {
      value.storyPoints = data.points;
    }
    if (data.teamId !== undefined) {
      value.teamId = data.teamId === null ? null : +data.teamId;
    }
    if (data.precondTeam !== undefined) {
      value.precondTeam = data.precondTeam.name;
      value.precondTeamId = +data.precondTeam.id;
    }
    if (data.dependTeam !== undefined) {
      value.dependTeam = data.dependTeam.name;
      value.dependTeamId = +data.dependTeam.id;
    }
    if (data.iterationId !== undefined) {
      value.iterationNumber = data.iterationId;
    }
    if (data.flagType !== undefined) {
      value.flagType = stickerToString(data.flagType);
    }
    if (data.risk !== undefined) {
      value.risk = data.risk;
    }
    if (data.almSourceId !== undefined) {
      value.almSource = data.almSourceId ?? undefined;
    }
    if (data.almId !== undefined) {
      value.almIssueId = data.almId;
    }
    if (data.artId !== undefined) {
      value.artId = data.artId === null ? null : Number(data.artId);
    }
    if (data.assignee !== undefined) {
      value.assignee = { pipId: data.assignee?.id || null, almId: null };
    }
  }
  return value;
}
